import { render, staticRenderFns } from "./InfoDescription.vue?vue&type=template&id=a1ef7df6&scoped=true&"
import script from "./InfoDescription.vue?vue&type=script&lang=js&"
export * from "./InfoDescription.vue?vue&type=script&lang=js&"
import style0 from "./InfoDescription.vue?vue&type=style&index=0&id=a1ef7df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ef7df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
